<div class="spinner">
  <div class="lds-grid">
    <!-- These divs must be empty -->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
